import "./attendance_reports.61a110c7.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1126"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1126"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cP3LP", function(module, exports) {

$parcel$export(module.exports, "get_parsed_jwt_identity", () => $955d2c31eafd4c00$export$390c178823cdcf97);
$parcel$export(module.exports, "formatDate", () => $955d2c31eafd4c00$export$3ae94a2503e890a1);
$parcel$export(module.exports, "showToast", () => $955d2c31eafd4c00$export$f6cef6fcf9ca4e17);
$parcel$export(module.exports, "showGlobalPreloader", () => $955d2c31eafd4c00$export$7fff75138c3118f5);
$parcel$export(module.exports, "hideGlobalPreloader", () => $955d2c31eafd4c00$export$2687b4119342c551);
$parcel$export(module.exports, "showCustomConfirm", () => $955d2c31eafd4c00$export$ae914c6c66f3a41d);
$parcel$export(module.exports, "initializeSidebar", () => $955d2c31eafd4c00$export$e2d71bdad8ced2ca);
// utils.js
// Shared utility functions for LukaIN platform
// --- Global State ---
window.preloaderCount = window.preloaderCount || 0;
function $955d2c31eafd4c00$export$390c178823cdcf97() {
    const token = localStorage.getItem("access_token");
    if (!token) return null;
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        const payload = JSON.parse(jsonPayload);
        if (payload.exp * 1000 < Date.now()) return null;
        if (payload.sub && typeof payload.sub === "object") return payload.sub;
        return payload.user_data || payload;
    } catch  {
        return null;
    }
}
const $955d2c31eafd4c00$export$3ae94a2503e890a1 = (dateStr)=>{
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "Invalid Date";
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
};
function $955d2c31eafd4c00$export$f6cef6fcf9ca4e17(message, type = "info", options = {}) {
    const toastContainer = document.getElementById("toast-container");
    if (!toastContainer) return;
    const toast = document.createElement("div");
    toast.className = `toast toast-${type}`;
    const iconClass = {
        success: "fa-check-circle",
        error: "fa-exclamation-circle",
        warning: "fa-exclamation-triangle",
        info: "fa-info-circle"
    }[type] || "fa-info-circle";
    toast.innerHTML = `
        <div class="toast-content">
            <i class="fas ${iconClass}"></i>
            <span>${message}</span>
        </div>
        <button class="toast-close" aria-label="Close"><i class="fas fa-times"></i></button>
    `;
    toastContainer.appendChild(toast);
    setTimeout(()=>{
        toast.classList.add("show");
    }, 10);
    const closeBtn = toast.querySelector(".toast-close");
    if (closeBtn) closeBtn.onclick = ()=>{
        toast.classList.remove("show");
        setTimeout(()=>{
            if (toast.parentNode) toast.remove();
        }, 400);
    };
    setTimeout(()=>{
        if (toast.parentNode) {
            toast.classList.remove("show");
            setTimeout(()=>{
                if (toast.parentNode) toast.remove();
            }, 400);
        }
    }, options.duration || 4000);
}
function $955d2c31eafd4c00$export$7fff75138c3118f5(message = "Processing...") {
    window.preloaderCount++;
    const preloader = document.getElementById("global-preloader");
    if (preloader) {
        const preloaderMessage = document.getElementById("global-preloader-message");
        if (preloaderMessage) {
            if (window.preloaderCount === 1 || message !== "Processing...") preloaderMessage.textContent = message;
        }
        preloader.style.display = "flex";
    }
}
function $955d2c31eafd4c00$export$2687b4119342c551() {
    if (window.preloaderCount > 0) window.preloaderCount--;
    if (window.preloaderCount === 0) {
        const preloader = document.getElementById("global-preloader");
        if (preloader) preloader.style.display = "none";
    }
}
function $955d2c31eafd4c00$export$ae914c6c66f3a41d(title, message, type = "info") {
    return new Promise((resolve)=>{
        // Check if modal already exists to prevent duplicates
        let modal = document.getElementById("custom-confirm-modal");
        if (!modal) {
            modal = document.createElement("div");
            modal.id = "custom-confirm-modal";
            modal.className = "custom-modal-overlay";
            modal.innerHTML = `
            <div class="custom-modal-content glass-card">
                <div class="custom-modal-header">
                    <h3 id="confirm-title">Confirm Action</h3>
                </div>
                <div class="custom-modal-body">
                    <p id="confirm-message">Are you sure you want to proceed?</p>
                </div>
                <div class="custom-modal-footer">
                    <button class="btn btn-secondary cancel-btn">Cancel</button>
                    <button class="btn btn-primary confirm-btn">Proceed</button>
                </div>
            </div>
        `;
            document.body.appendChild(modal);
        }
        const titleEl = document.getElementById("confirm-title");
        const messageEl = document.getElementById("confirm-message");
        const confirmBtn = modal.querySelector(".confirm-btn");
        const cancelBtn = modal.querySelector(".cancel-btn");
        titleEl.textContent = title;
        messageEl.textContent = message;
        // Apply specific type styles
        confirmBtn.className = `btn btn-primary confirm-btn ${type === "danger" ? "btn-danger" : type === "warning" ? "btn-warning" : ""}`;
        // Show modal with animation
        modal.classList.add("show");
        // Clear old event listeners
        const newConfirmBtn = confirmBtn.cloneNode(true);
        confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
        const newCancelBtn = cancelBtn.cloneNode(true);
        cancelBtn.parentNode.replaceChild(newCancelBtn, cancelBtn);
        newConfirmBtn.onclick = ()=>{
            modal.classList.remove("show");
            resolve(true);
        };
        newCancelBtn.onclick = ()=>{
            modal.classList.remove("show");
            resolve(false);
        };
        // Allow closing on overlay click
        modal.onclick = (e)=>{
            if (e.target === modal) {
                modal.classList.remove("show");
                resolve(false);
            }
        };
    });
}
function $955d2c31eafd4c00$export$e2d71bdad8ced2ca(userRole) {
    const sidebar = document.querySelector(".sidebar");
    if (!sidebar) return;
    if (!userRole) userRole = localStorage.getItem("user_role");
    if (!userRole) return;
    // 1. REBUILD SIDEBAR TO ENSURE TOP-DOWN ORDER
    sidebar.innerHTML = "";
    // 2. LOGO SECTION (ABSOLUTE TOP)
    const logoDiv = document.createElement("div");
    logoDiv.className = "logo";
    logoDiv.innerHTML = `
      <div class="logo-brand">
          <img src="LukaIN_System_Group_LOGO.png" alt="LukaIN Logo" class="logo-img" onerror="this.src='/favicon.png'">
          <span>LukaIN</span>
      </div>
      <button class="sidebar-close-btn hide-desktop" id="sidebar-close-btn" aria-label="Close sidebar">
          <i class="fas fa-times"></i>
      </button>
  `;
    sidebar.appendChild(logoDiv);
    // 3. NAVIGATION SECTION
    const nav = document.createElement("nav");
    nav.className = "sidebar-nav";
    sidebar.appendChild(nav);
    $955d2c31eafd4c00$var$populateSidebarLinks(nav, userRole);
    $955d2c31eafd4c00$var$injectUnifiedFooter();
    // 4. SETUP MOBILE TOGGLES
    // setupMobileToggles(); // Handled globally in common.js
    // Internal Close Button logic (Mobile only)
    const closeBtn = document.getElementById("sidebar-close-btn");
    if (closeBtn) closeBtn.onclick = (e)=>{
        e.preventDefault();
        const sidebarEl = document.querySelector(".sidebar");
        const toggle = document.querySelector(".sidebar-toggle");
        if (sidebarEl) sidebarEl.classList.remove("active");
        if (toggle) toggle.classList.remove("is-active");
        document.body.classList.remove("sidebar-open");
        const overlay = document.querySelector(".sidebar-overlay");
        if (overlay) overlay.style.display = "none";
    };
}
function $955d2c31eafd4c00$var$injectUnifiedFooter() {
    const mainContent = document.querySelector(".main-dashboard-content");
    if (!mainContent) return;
    // Remove ALL existing footers to prevent duplicates
    const existingFooters = document.querySelectorAll("footer, .main-footer-dark, .hud-footer");
    existingFooters.forEach((f)=>f.remove());
    const footer = document.createElement("footer");
    footer.className = "main-footer-dark";
    footer.innerHTML = `
        <div class="footer-content">
            <div class="footer-logo">
                <div class="logo">
                    <img src="LukaIN_System_Group_LOGO.png" alt="LukaIN Logo" class="logo-img">
                    <span>LukaIN</span>
                </div>
                <p>Empowering organizations with Professional, automated management tools. Built for efficiency, designed for the future.</p>
            </div>
            <div class="footer-links">
                <h4>Product</h4>
                <a href="/landing#features">Key Features</a>
                <a href="/pricing">Pricing Plans</a>
                <a href="/help">Help Center</a>
                <a href="/support_ticket">Support Portal</a>
            </div>
            <div class="footer-links">
                <h4>Company</h4>
                <a href="/about">Our Story</a>
                <a href="/contact">Get in Touch</a>
                <a href="mailto:luckybasera123@gmail.com">Direct Email</a>
            </div>
            <div class="footer-links">
                <h4>Legal</h4>
                <a href="/terms">Terms of Service</a>
                <a href="/privacy_policy">Privacy Policy</a>
                <a href="/cancellations_refunds">Refund Policy</a>
                <a href="/deleteUser">Request Account Deletion</a>
            </div>
        </div>
        <div class="footer-bottom">
            <p>&copy; 2025-2026 LukaIN Technologies Pvt. Ltd. All rights reserved. Crafted with precision in India.</p>
        </div>
    `;
    mainContent.appendChild(footer);
}
function $955d2c31eafd4c00$var$populateSidebarLinks(nav, userRole) {
    const currentPage = window.location.pathname.split("/").pop();
    const identity = $955d2c31eafd4c00$export$390c178823cdcf97();
    const workplaceType = identity ? identity.workplace_type || "School" : "School";
    // Customization mapping
    const labelsMap = {
        School: {
            members: "Students & Staff",
            erp: "School Tools",
            member_sub: "Students & Staff",
            schedule: "Timetable",
            attendance: "Attendance"
        },
        Coaching: {
            members: "Aspirants & Instructors",
            erp: "Coaching Tools",
            member_sub: "Aspirants & Instructors",
            schedule: "Batch Schedule",
            attendance: "Attendance"
        },
        Office: {
            members: "Team & Employees",
            erp: "Office Tools",
            member_sub: "Staff & Team",
            schedule: "Work Schedule",
            attendance: "Presence"
        },
        Hospital: {
            members: "Patients & Medical Staff",
            erp: "Hospital Tools",
            member_sub: "Patients & Doctors",
            schedule: "Rounds Schedule",
            attendance: "Rounds"
        },
        Factory: {
            members: "Workers & Supervisors",
            erp: "Factory Tools",
            member_sub: "Workers & Staff",
            schedule: "Shift Schedule",
            attendance: "Shifts"
        },
        Gym: {
            members: "Clients & Trainers",
            erp: "Gym Tools",
            member_sub: "Clients & Trainers",
            schedule: "Training Schedule",
            attendance: "Check-in"
        },
        Hotel: {
            members: "Guests & Hospitality Team",
            erp: "Hotel Tools",
            member_sub: "Guests & Staff",
            schedule: "Service Schedule",
            attendance: "Presence"
        },
        Other: {
            members: "Team Members",
            erp: "Main Tools",
            member_sub: "All Members",
            schedule: "Schedule",
            attendance: "Attendance"
        }
    };
    const labels = labelsMap[workplaceType] || labelsMap["Other"];
    const ROUTES_CONFIG = {
        admin: [
            {
                href: "admindashboard.html",
                icon: "fa-tachometer-alt",
                text: "Dashboard"
            },
            {
                href: "member_management.html",
                icon: "fa-users",
                text: labels.members
            },
            {
                href: "erp_management.html",
                icon: "fa-book",
                text: labels.erp
            },
            {
                href: "timetable_management.html",
                icon: "fa-calendar-alt",
                text: labels.schedule
            },
            {
                href: "messaging_center.html",
                icon: "fa-envelope",
                text: "Messaging"
            },
            {
                href: "attendance.html",
                icon: "fa-qrcode",
                text: "QR Attendance"
            },
            {
                href: "manual_attendance.html",
                icon: "fa-user-check",
                text: "Manual Attendance"
            },
            {
                href: "download_center.html",
                icon: "fa-download",
                text: "Download Center"
            },
            {
                href: "attendance_reports.html",
                icon: "fa-file-alt",
                text: "Reports"
            },
            {
                href: "settings.html",
                icon: "fa-cog",
                text: "Settings"
            }
        ],
        chairman: [
            {
                href: "superadmindashboard.html",
                icon: "fa-user-shield",
                text: "Dashboard"
            },
            {
                href: "organization_management.html",
                icon: "fa-building",
                text: "Organizations"
            },
            {
                href: "enterprise_requests.html",
                icon: "fa-briefcase",
                text: "Enterprise"
            },
            {
                href: "admin_approval.html",
                icon: "fa-user-check",
                text: "Approvals"
            },
            {
                href: "deletion_approval.html",
                icon: "fa-user-minus",
                text: "Deletion Requests"
            },
            {
                href: "system-metrics.html",
                icon: "fa-chart-bar",
                text: "Metrics"
            },
            {
                href: "manage_tickets.html",
                icon: "fa-ticket-alt",
                text: "Support"
            },
            {
                href: "superadmin-settings.html",
                icon: "fa-cog",
                text: "Settings"
            }
        ],
        teacher: [
            {
                href: "teacherdashboard.html",
                icon: "fa-tachometer-alt",
                text: "Dashboard"
            },
            {
                href: "member_management.html",
                icon: "fa-users",
                text: labels.member_sub
            },
            {
                href: "attendance.html",
                icon: "fa-qrcode",
                text: "QR Attendance"
            },
            {
                href: "manual_attendance.html",
                icon: "fa-user-check",
                text: "Manual Attendance"
            }
        ],
        parent: [
            {
                href: "parentdashboard.html",
                icon: "fa-tachometer-alt",
                text: "Dashboard"
            },
            {
                href: "attendance_reports.html",
                icon: "fa-file-alt",
                text: labels.attendance || "Attendance"
            }
        ]
    };
    const roleLinks = ROUTES_CONFIG[userRole] || [];
    let linksHTML = "";
    roleLinks.forEach((link)=>{
        const isActive = currentPage === link.href ? "active" : "";
        linksHTML += `<a href="${link.href}" class="${isActive}"><i class="icon fas ${link.icon}"></i>${link.text}</a>`;
    });
    nav.innerHTML = linksHTML;
}

});


var $cP3LP = parcelRequire("cP3LP");

var $bm3Mu = parcelRequire("bm3Mu");
// common.js
// Standardized global utilities for LukaIN platform
(function() {
    var THIRD_PARTY_PATTERNS = [
        /chrome-extension:\/\//i,
        /moz-extension:\/\//i,
        /edge-extension:\/\//i,
        /domInject\.js/i,
        /contentscript\.js/i,
        /for-embedded-agent\.js/i,
        /noupe\.com/i,
        /clientKey/i,
        /The target origin provided/i,
        /postMessage/i,
        /message port closed/i,
        /ObjectMultiplex/i,
        /MaxListenersExceededWarning/i,
        /orphaned data for stream/i,
        /Fullstory session cannot be created/i,
        /Grammarly/i,
        /grammarly-check/i,
        /AssistantLoadState/i,
        /has already been declared/i,
        /Permissions policy violation/i,
        /unload is not allowed/i,
        /DOMException/i,
        /SecurityError/i,
        /Failed to execute 'postMessage'/i,
        /Failed to execute "postMessage"/i,
        /portalInitialSuggestionsPromise/i,
        /Page data capture skipped/i,
        /answerCurrentQuestion/i,
        /capturePageData/i,
        /DEFAULT root logger/i,
        /Using DEFAULT root logger/i,
        /script\.onload/i,
        /01a08e168278700089a53912cc5a364e23c3/i,
        /Error handling response/i,
        /resumeStreamIfNeeded/i,
        /shouldResume/i,
        /screen-sharing-active/i,
        /isScreenSharingActive/i,
        /This chat is recorded/i,
        /AI Terms/i
    ];
    function containsAnyFingerprint(args) {
        if (!args || args.length === 0) return false;
        for(var i = 0; i < args.length; i++){
            var a = args[i];
            var s;
            if (a == null) continue;
            if (typeof a === "string") s = a;
            else if (a instanceof Error) s = String(a.message || "") + " " + String(a.stack || "");
            else try {
                s = String(a);
            } catch (_e) {
                continue;
            }
            for(var j = 0; j < THIRD_PARTY_PATTERNS.length; j++){
                if (THIRD_PARTY_PATTERNS[j].test(s)) return true;
            }
        }
        return false;
    }
    var globalConsole = typeof console !== "undefined" ? console : null;
    if (globalConsole) {
        var METHODS = [
            "log",
            "warn",
            "error",
            "info",
            "debug",
            "trace"
        ];
        for(var m = 0; m < METHODS.length; m++){
            var name = METHODS[m];
            var orig = globalConsole[name];
            if (typeof orig !== "function") continue;
            (function(methodName, original) {
                globalConsole[methodName] = function() {
                    if (containsAnyFingerprint(arguments)) return;
                    return original.apply(globalConsole, arguments);
                };
            })(name, orig);
        }
    }
    function isThirdPartyNoise(msg, url, lineNo, columnNo, error) {
        var haystack = String(msg || "") + " " + String(url || "") + " ";
        if (error && error.stack) haystack += String(error.stack);
        for(var i = 0; i < THIRD_PARTY_PATTERNS.length; i++){
            if (THIRD_PARTY_PATTERNS[i].test(haystack)) return true;
        }
        return false;
    }
    var prevOnError = window.onerror;
    window.onerror = function(msg, url, lineNo, columnNo, error) {
        if (isThirdPartyNoise(msg, url, lineNo, columnNo, error)) return true;
        if (typeof prevOnError === "function") try {
            return prevOnError(msg, url, lineNo, columnNo, error);
        } catch (_e) {}
        return false;
    };
    var prevOnRejection = window.onunhandledrejection;
    window.onunhandledrejection = function(event) {
        var reason = "";
        if (event) {
            if (typeof event.reason === "string") reason = event.reason;
            else if (event.reason) reason = String(event.reason.message || "") + " " + String(event.reason.stack || "");
        }
        if (isThirdPartyNoise(reason, "", 0, 0, event && event.reason)) {
            if (event && typeof event.preventDefault === "function") try {
                event.preventDefault();
            } catch (_e) {}
            return;
        }
        if (typeof prevOnRejection === "function") try {
            prevOnRejection(event);
        } catch (_e) {}
    };
})();
// ── PHASE 9 SECURITY REMEDIATION: DOM XSS helpers ──────────────────────
// Escape any untrusted plain-text string before it reaches innerHTML.
// Prefer createElement()+textContent() where possible; use escapeHtml()
// only when a markup template genuinely requires string interpolation.
function $74bb8a2006e9dcfb$export$4cf11838cdc2a8a8(unsafe) {
    if (unsafe === null || unsafe === undefined) return "";
    return String(unsafe).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
// Deprecated: use createElement + textContent directly instead.
// Kept as a defense-in-drop for legacy rows that still use string templates.
function $74bb8a2006e9dcfb$export$8373c0da8bd5dee5(el, htmlString, trustedContext) {
    if (!el) return;
    const purified = typeof window.DOMPurify !== "undefined" && window.DOMPurify.sanitize ? window.DOMPurify.sanitize(htmlString, trustedContext || {}) : htmlString;
    el.innerHTML = purified;
}
// Attach to window for global access in HTML inline scripts
window.get_parsed_jwt_identity = (0, $cP3LP.get_parsed_jwt_identity);
window.showGlobalPreloader = (0, $cP3LP.showGlobalPreloader);
window.hideGlobalPreloader = (0, $cP3LP.hideGlobalPreloader);
window.initializeSidebar = (0, $cP3LP.initializeSidebar);
window.showToast = (0, $cP3LP.showToast);
window.formatDate = (0, $cP3LP.formatDate);
window.showCustomConfirm = (0, $cP3LP.showCustomConfirm);
window.escapeHtml = $74bb8a2006e9dcfb$export$4cf11838cdc2a8a8;
window.setSafeInnerHTML = $74bb8a2006e9dcfb$export$8373c0da8bd5dee5;
// --- Global State ---
window.originalFetch = window.fetch;
var $74bb8a2006e9dcfb$var$originalFetch = window.fetch; // Keep local for the wrapper below
document.addEventListener("DOMContentLoaded", ()=>{
    // 1. Unified Navigation Toggle (Sidebar and Public Navbar)
    document.addEventListener("click", (e)=>{
        // A. Sidebar Toggle (Dashboards)
        const sidebarToggle = e.target.closest(".sidebar-toggle");
        const sidebar = document.querySelector(".sidebar");
        if (sidebarToggle && sidebar) {
            e.stopPropagation();
            const isActive = sidebar.classList.toggle("active");
            sidebarToggle.classList.toggle("is-active", isActive);
            document.body.classList.toggle("sidebar-open", isActive);
            // Create or toggle overlay
            let overlay = document.querySelector(".sidebar-overlay");
            if (!overlay) {
                overlay = document.createElement("div");
                overlay.className = "sidebar-overlay";
                document.body.appendChild(overlay);
            }
            overlay.style.display = isActive ? "block" : "none";
        }
        // Close sidebar when clicking overlay
        if (e.target.classList.contains("sidebar-overlay")) {
            const sidebar = document.querySelector(".sidebar");
            const sidebarToggle = document.querySelector(".sidebar-toggle");
            if (sidebar) sidebar.classList.remove("active");
            if (sidebarToggle) sidebarToggle.classList.remove("is-active");
            document.body.classList.remove("sidebar-open");
            e.target.style.display = "none";
        }
        // B. Public Navbar Toggle (Landing, About, etc.)
        const menuToggle = e.target.closest(".menu-toggle");
        const navLinks = document.querySelector(".nav-links");
        if (menuToggle) {
            e.stopPropagation();
            const isOpen = navLinks ? navLinks.classList.toggle("nav-open") : false;
            menuToggle.classList.toggle("active", isOpen);
            menuToggle.classList.toggle("is-active", isOpen);
        }
    });
    // Close menu when clicking outside
    document.addEventListener("click", (e)=>{
        const navLinks = document.querySelector(".nav-links");
        const menuToggle = document.querySelector(".menu-toggle");
        if (navLinks && navLinks.classList.contains("nav-open") && !e.target.closest(".nav-links") && !e.target.closest(".menu-toggle")) {
            navLinks.classList.remove("nav-open");
            if (menuToggle) {
                menuToggle.classList.remove("active");
                menuToggle.classList.remove("is-active");
            }
        }
    });
    // Initial sidebar state
    function setInitialSidebarState() {
        const sidebar = document.querySelector(".sidebar");
        if (!sidebar) return;
        if (window.innerWidth > 1024) {
            sidebar.classList.add("active");
            document.body.classList.add("sidebar-open");
        } else {
            sidebar.classList.remove("active");
            document.body.classList.remove("sidebar-open");
        }
    }
    setInitialSidebarState();
    window.addEventListener("resize", setInitialSidebarState);
    // --- Dropdown Initialization ---
    // Convert selects FIRST
    (0, $bm3Mu.convertSelectsToCustomDropdowns)();
    // Initialize any hardcoded custom dropdowns
    document.querySelectorAll(".custom-dropdown").forEach((0, $bm3Mu.initializeDropdown));
    // Observer for dynamic content
    const observer = new MutationObserver((0, $bm3Mu.convertSelectsToCustomDropdowns));
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Close all dropdowns if clicked outside
    window.addEventListener("click", (e)=>{
        document.querySelectorAll(".custom-dropdown.open").forEach((dropdown)=>{
            if (!dropdown.contains(e.target)) dropdown.classList.remove("open");
        });
    });
    // Toast Container initialization
    const existing = document.getElementById("toast-container");
    if (!existing) {
        const el = document.createElement("div");
        el.id = "toast-container";
        el.className = "toast-container";
        document.body.appendChild(el);
    }
    // --- Authentication & Role Handling ---
    try {
        const userData = (0, $cP3LP.get_parsed_jwt_identity)();
        if (userData) {
            const navLogin = document.getElementById("nav-login");
            const navSignup = document.getElementById("nav-signup");
            const navLogout = document.getElementById("nav-logout");
            const navDashboard = document.getElementById("nav-dashboard");
            const userRole = userData.role;
            const token = localStorage.getItem("access_token");
            if (token && (userRole === "admin" || userRole === "chairman")) // Background update of plan info
            fetch("/api/user/plan", {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "X-Background-Request": "true"
                }
            }).then((res)=>res.json()).then((planData)=>{
                if (planData && planData.name) {
                    const newTier = planData.name.toLowerCase();
                    if (localStorage.getItem("user_subscription_tier") !== newTier) {
                        localStorage.setItem("user_subscription_tier", newTier);
                        (0, $cP3LP.initializeSidebar)(userRole);
                    }
                }
            }).catch(()=>{});
            localStorage.setItem("user_role", userRole);
            // Initialize Sidebar
            (0, $cP3LP.initializeSidebar)(userRole);
            if (navLogin) navLogin.style.display = "none";
            if (navSignup) navSignup.style.display = "none";
            if (navLogout) navLogout.style.display = "list-item";
            if (navDashboard) {
                navDashboard.style.display = "list-item";
                const dashboardLink = navDashboard.querySelector("a");
                if (dashboardLink) dashboardLink.href = userRole === "chairman" ? "superadmindashboard.html" : "admindashboard.html";
            }
            const logoutButton = document.getElementById("logout-button");
            if (logoutButton) logoutButton.addEventListener("click", ()=>{
                localStorage.clear();
                window.showToast("You have been logged out.", "info");
                setTimeout(()=>{
                    window.location.href = "/landing";
                }, 1500);
            });
            // Workplace-specific terminology
            const workplaceType = userData.workplace_type || "School";
            const terminology = {
                School: {
                    staff: "Teachers",
                    member: "Students",
                    members: "Students",
                    parent: "Parents",
                    parents: "Parents",
                    child: "Student",
                    children: "Students",
                    class: "Class",
                    classes: "Classes",
                    section: "Section",
                    attendance: "Attendance",
                    management: "School Management",
                    tools: "School Tools",
                    add_member: "Add New Student/Teacher",
                    staff_member: "Teacher/Staff Member",
                    subject_spec: "Subject / Specialization",
                    academic_records: "Student Profiles",
                    performance_hub: "Academic Performance",
                    library: "Library System",
                    substitution: "Substitution Hub",
                    hr_leaves: "Staff HR & Leaves"
                },
                Coaching: {
                    staff: "Instructors",
                    member: "Aspirants",
                    members: "Aspirants",
                    parent: "Guardians",
                    parents: "Guardians",
                    child: "Aspirant",
                    children: "Aspirants",
                    class: "Batch",
                    classes: "Batches",
                    section: "Group",
                    attendance: "Attendance",
                    management: "Coaching Management",
                    tools: "Coaching Tools",
                    add_member: "Add New Aspirant/Instructor",
                    staff_member: "Instructor Member",
                    subject_spec: "Subject / Expertise",
                    academic_records: "Aspirant Profiles",
                    performance_hub: "Test Results",
                    library: "Resource Center",
                    substitution: "Instructor Replacement",
                    hr_leaves: "Instructor HR & Leaves"
                },
                Office: {
                    staff: "Employees",
                    member: "Team Members",
                    members: "Team Members",
                    parent: "Contact Person",
                    parents: "Contact Persons",
                    child: "Employee",
                    children: "Employees",
                    class: "Department",
                    classes: "Departments",
                    section: "Team",
                    attendance: "Presence",
                    management: "Office Management",
                    tools: "Office Tools",
                    add_member: "Add New Employee",
                    staff_member: "Employee Member",
                    subject_spec: "Role / Department",
                    academic_records: "Employee Files",
                    performance_hub: "KPIs & Appraisals",
                    library: "Digital Assets",
                    substitution: "Task Delegation",
                    hr_leaves: "Employee HR & Leaves"
                },
                Hospital: {
                    staff: "Medical Staff",
                    member: "Patients",
                    members: "Patients",
                    parent: "Relatives",
                    parents: "Relatives",
                    child: "Patient",
                    children: "Patients",
                    class: "Ward",
                    classes: "Wards",
                    section: "Unit",
                    attendance: "Rounds",
                    management: "Hospital Management",
                    tools: "Medical Tools",
                    add_member: "Add New Patient/Staff",
                    staff_member: "Medical Staff Member",
                    subject_spec: "Specialization / Department",
                    academic_records: "Patient Records",
                    performance_hub: "Health Analytics",
                    library: "Medical Library",
                    substitution: "On-call Roster",
                    hr_leaves: "Staff HR & Leaves"
                },
                Factory: {
                    staff: "Supervisors",
                    member: "Workers",
                    members: "Workers",
                    parent: "Emergency Contact",
                    parents: "Emergency Contacts",
                    child: "Worker",
                    children: "Workers",
                    class: "Line",
                    classes: "Lines",
                    section: "Shift",
                    attendance: "Shift Record",
                    management: "Factory Management",
                    tools: "Production Tools",
                    add_member: "Add New Worker/Supervisor",
                    staff_member: "Supervisor Member",
                    subject_spec: "Skill / Line",
                    academic_records: "Worker Profiles",
                    performance_hub: "Output Analytics",
                    library: "Inventory Log",
                    substitution: "Shift Reassignment",
                    hr_leaves: "Worker HR & Leaves"
                },
                Gym: {
                    staff: "Trainers",
                    member: "Clients",
                    members: "Clients",
                    parent: "Spouse/Relative",
                    parents: "Relatives",
                    child: "Client",
                    children: "Clients",
                    class: "Program",
                    classes: "Programs",
                    section: "Batch",
                    attendance: "Check-in",
                    management: "Gym Management",
                    tools: "Fitness Tools",
                    add_member: "Add New Client/Trainer",
                    staff_member: "Trainer Member",
                    subject_spec: "Expertise / Program",
                    academic_records: "Client Profiles",
                    performance_hub: "Fitness Progress",
                    library: "Equipment Log",
                    substitution: "Trainer Replacement",
                    hr_leaves: "Trainer HR & Leaves"
                },
                Hotel: {
                    staff: "Staff",
                    member: "Guest",
                    members: "Guests",
                    parent: "Sponsor",
                    parents: "Sponsors",
                    child: "Guest",
                    children: "Guests",
                    class: "Room Type",
                    classes: "Room Types",
                    section: "Floor",
                    attendance: "Check-in Status",
                    management: "Hotel Management",
                    tools: "Service Tools",
                    add_member: "Add New Guest/Staff",
                    staff_member: "Staff Member",
                    subject_spec: "Department / Role",
                    academic_records: "Guest History",
                    performance_hub: "Service Quality",
                    library: "Facility Assets",
                    substitution: "Duty Rotation",
                    hr_leaves: "Staff HR & Leaves"
                }
            };
            const terms = terminology[workplaceType] || terminology.School;
            document.querySelectorAll("[data-i18n]").forEach((el)=>{
                const key = el.getAttribute("data-i18n");
                if (terms[key]) {
                    if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
                        if (el.placeholder) el.placeholder = el.placeholder.replace(/Student|Teacher|Staff|Parent|Member|Class|Timetable/g, terms[key]);
                    } else {
                        // Preserve icons if present
                        const icon = el.querySelector('i.fas, i.far, i.fab, i.fa-solid');
                        if (icon) {
                            const iconHtml = icon.outerHTML;
                            el.innerHTML = `${iconHtml} ${terms[key]}`;
                        } else el.textContent = terms[key];
                    }
                }
            });
        }
    } catch  {
        // Fallback for public state
        const navLogin = document.getElementById("nav-login");
        if (navLogin) navLogin.style.display = "list-item";
    }
});
/**
 * Global Fetch Wrapper with Integrated Preloader
 */ window.fetch = async function(input, init = {}) {
    let isBackground = false;
    let hadAuthHeader = false;
    if (init.headers) {
        const headers = init.headers;
        isBackground = headers["X-Background-Request"] === "true" || headers["x-background-request"] === "true";
        const auth = headers["Authorization"] || headers["authorization"];
        hadAuthHeader = !!(auth && String(auth).startsWith("Bearer "));
    }
    if (!isBackground) (0, $cP3LP.showGlobalPreloader)();
    try {
        const response = await $74bb8a2006e9dcfb$var$originalFetch(input, init);
        if (response.status === 401) {
            const hasStoredToken = !!localStorage.getItem("access_token");
            if (hadAuthHeader && hasStoredToken) {
                localStorage.removeItem("access_token");
                localStorage.removeItem("user_role");
                localStorage.removeItem("refresh_token");
                localStorage.removeItem("user_id");
                localStorage.removeItem("username");
                const path = window.location.pathname;
                if (path !== "/login" && path !== "/landing" && path !== "/") window.location.href = "/login";
            }
        }
        return response;
    } finally{
        if (!isBackground) (0, $cP3LP.hideGlobalPreloader)();
    }
};
// ============================================================================
// LukaDataCache — client-side TTL cache with stale-while-revalidate (Phase 2.2)
// ============================================================================
(function(global) {
    'use strict';
    const DEFAULT_TTL_MS = 5000;
    const STATIC_TTL_MS = 30000;
    const LONG_TTL_MS = 120000;
    const MAX_ENTRIES = 512;
    const store = new Map();
    function now() {
        return Date.now();
    }
    function evictIfNeeded() {
        if (store.size <= MAX_ENTRIES) return;
        const toRemove = store.size - MAX_ENTRIES;
        let removed = 0;
        for (const key of store.keys()){
            if (removed >= toRemove) break;
            store.delete(key);
            removed++;
        }
    }
    function standardKey(endpoint, params) {
        let base = endpoint;
        if (params) {
            const str = typeof params === 'string' ? params : JSON.stringify(params, Object.keys(params || {}).sort());
            base = base + '::' + str;
        }
        // Prefix with institution if available for tenant isolation
        try {
            const raw = localStorage.getItem('user_identity');
            if (raw) {
                const ident = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (ident && ident.institution_id) base = `inst:${ident.institution_id}::${base}`;
            }
        } catch (_id) {
        /* ignore */ }
        return base;
    }
    function get(key) {
        const entry = store.get(key);
        if (!entry) return undefined;
        if (now() > entry.expiresAt) // Entry exists but is stale. Caller may still want it for SWR.
        return {
            stale: true,
            value: entry.value,
            expiresAt: entry.expiresAt
        };
        return {
            stale: false,
            value: entry.value,
            expiresAt: entry.expiresAt
        };
    }
    function set(key, value, ttlMs) {
        const ttl = typeof ttlMs === 'number' ? ttlMs : DEFAULT_TTL_MS;
        store.set(key, {
            value: value,
            expiresAt: now() + ttl
        });
        evictIfNeeded();
    }
    /**
   * Primary API: fetch via global.fetch, using SWR cache pattern.
   * - Cache HIT (fresh): return cached value immediately, no revalidation.
   * - Cache HIT (stale, within extra window): return cached value IMMEDIATELY,
   *   then fire background revalidation fetch (stored into cache).
   * - Cache MISS (or stale too long): fetch, cache, return value.
   */ async function fetchCached(endpoint, fetchOptions, opts) {
        opts = opts || {};
        const key = standardKey(endpoint, opts.params);
        const ttl = opts.ttlMs != null ? opts.ttlMs : DEFAULT_TTL_MS;
        const staleExtra = opts.staleWhileRevalidateMs != null ? opts.staleWhileRevalidateMs : 25000;
        const hit = get(key);
        // Case 1: fresh hit within TTL
        if (hit && !hit.stale) try {
            const cloned = JSON.parse(JSON.stringify(hit.value));
            return cloned;
        } catch (_c1) {
            return hit.value;
        }
        // Case 2: stale hit within revalidation window — return stale, kick off bg fetch
        if (hit && hit.stale && now() <= hit.expiresAt + staleExtra) {
            const staleValue = hit.value;
            // Fire and forget the background revalidation
            Promise.resolve().then(()=>$74bb8a2006e9dcfb$var$originalFetch(endpoint, fetchOptions || {})).then((r)=>{
                if (!r.ok) throw new Error('bg fetch not ok');
                return r.json();
            }).then((fresh)=>set(key, fresh, ttl)).catch(()=>{
            /* bg revalidation failures are swallowed */ });
            try {
                return JSON.parse(JSON.stringify(staleValue));
            } catch (_c2) {
                return staleValue;
            }
        }
        // Case 3: miss or stale expired — fetch fresh now
        const resp = await global.fetch(endpoint, fetchOptions || {});
        let body;
        try {
            body = await resp.json();
        } catch (_c3) {
            body = null;
        }
        if (resp.ok && body) set(key, body, ttl);
        return body;
    }
    function invalidatePattern(prefix) {
        if (!prefix) return clear();
        let count = 0;
        for (const key of Array.from(store.keys()))if (key.indexOf(prefix) === 0) {
            store.delete(key);
            count++;
        }
        return count;
    }
    function clear() {
        const count = store.size;
        store.clear();
        return count;
    }
    global.LukaDataCache = {
        TTL_DEFAULT: DEFAULT_TTL_MS,
        TTL_STATIC: STATIC_TTL_MS,
        TTL_LONG: LONG_TTL_MS,
        get: get,
        set: set,
        fetchCached: fetchCached,
        key: standardKey,
        invalidatePattern: invalidatePattern,
        clear: clear,
        _size: ()=>store.size
    };
})(window);
// ============================================================================
// Sidebar Hover Prefetch (Phase 2.7) — 150ms hover → fire → LukaDataCache
// ============================================================================
(function(global) {
    'use strict';
    const HOVER_DELAY_MS = 150;
    const timers = new WeakMap();
    const fired = new Set();
    // Map of URL path → API endpoint(s) to prefetch when user hovers sidebar link
    const PAGE_TO_API = {
        '/member_management': [
            {
                endpoint: '/api/members/members/summary',
                ttlMs: 60000
            },
            {
                endpoint: '/api/members/members?page_size=50',
                ttlMs: 5000
            }
        ],
        '/audit-logs': [
            {
                endpoint: '/api/audit/logs/summary',
                ttlMs: 60000
            },
            {
                endpoint: '/api/audit/logs?page_size=50',
                ttlMs: 5000
            }
        ],
        '/manage_tickets': [
            {
                endpoint: '/api/support/admin/tickets/summary',
                ttlMs: 60000
            },
            {
                endpoint: '/api/support/admin/tickets?page_size=50',
                ttlMs: 5000
            }
        ],
        '/attendance_reports': [
            {
                endpoint: '/api/admin/dashboard-data',
                ttlMs: 30000
            }
        ],
        '/timetable_management': [
            {
                endpoint: '/api/timetable',
                ttlMs: 30000
            }
        ],
        '/admindashboard': [
            {
                endpoint: '/api/admin/dashboard-data',
                ttlMs: 30000
            }
        ],
        '/erp_management': [
            {
                endpoint: '/api/erp/classrooms',
                ttlMs: 30000
            },
            {
                endpoint: '/api/erp/subjects',
                ttlMs: 30000
            }
        ]
    };
    function authHeaders() {
        const token = localStorage.getItem('access_token');
        if (!token) return null;
        return {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'X-Background-Request': 'true'
        };
    }
    function firePrefetch(pathname) {
        const rules = PAGE_TO_API[pathname];
        if (!rules || !rules.length) return;
        const hdrs = authHeaders();
        if (!hdrs) return;
        for (const rule of rules){
            const key = window.LukaDataCache.key(rule.endpoint);
            if (fired.has(key)) continue;
            fired.add(key);
            // 5 min cool-down before re-prefetching identical endpoint
            setTimeout(()=>fired.delete(key), 300000);
            window.LukaDataCache.fetchCached(rule.endpoint, {
                headers: hdrs
            }, {
                ttlMs: rule.ttlMs
            }).catch(()=>{
            /* prefetch fail is silent */ });
        }
    }
    function onEnter(el, pathname) {
        if (timers.has(el)) return;
        const t = setTimeout(()=>firePrefetch(pathname), HOVER_DELAY_MS);
        timers.set(el, t);
    }
    function onLeave(el) {
        const t = timers.get(el);
        if (t) {
            clearTimeout(t);
            timers.delete(el);
        }
    }
    function attach() {
        try {
            const sidebarLinks = document.querySelectorAll('nav.sidebar a, .sidebar a, #sidebar a, aside a, [data-sidebar-link]');
            sidebarLinks.forEach((a)=>{
                if (!a || a.dataset.prefetchBound === '1') return;
                let target = a.getAttribute('href') || '';
                if (!target || target.startsWith('#') || target.startsWith('http')) return;
                if (target.indexOf('?') >= 0) target = target.slice(0, target.indexOf('?'));
                a.addEventListener('mouseenter', ()=>onEnter(a, target));
                a.addEventListener('mouseleave', ()=>onLeave(a));
                a.addEventListener('focus', ()=>onEnter(a, target));
                a.addEventListener('blur', ()=>onLeave(a));
                a.dataset.prefetchBound = '1';
            });
        } catch (_sp) {
        /* no sidebar on this page */ }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
    else {
        attach();
        // Re-attach after a short delay in case sidebar renders later (SPA-like)
        setTimeout(attach, 1500);
        setTimeout(attach, 5000);
    }
    global.LukaSidebarPrefetch = {
        attach: attach,
        firePrefetch: firePrefetch,
        PAGE_TO_API: PAGE_TO_API
    };
})(window);
// ============================================================================
// Frontend Perf Beacon (Phase 3.1) — best-effort; POST every 100th sample
// ============================================================================
(function(global) {
    'use strict';
    let sampleCounter = 0;
    const DEV_MODE = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const SAMPLE_EVERY_N = DEV_MODE ? 1 : 100;
    const ENDPOINT = '/api/metrics/frontend-perf';
    function detectRoute() {
        const path = window.location.pathname || '';
        const last = path.split('/').filter(Boolean).pop();
        return last || 'landing';
    }
    function connInfo() {
        const c = global.navigator && global.navigator.connection;
        return c ? c.effectiveType : 'n/a';
    }
    function deviceMem() {
        return global.navigator && typeof global.navigator.deviceMemory === 'number' ? global.navigator.deviceMemory : 'n/a';
    }
    function getInstitutionId() {
        try {
            const raw = localStorage.getItem('user_identity');
            if (raw) {
                const ident = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (ident && ident.institution_id) return ident.institution_id;
            }
        } catch (_gi) {
        /* ignore */ }
        return undefined;
    }
    function record(sample) {
        try {
            sampleCounter++;
            if (!DEV_MODE && sampleCounter % SAMPLE_EVERY_N !== 0) return;
            if (!sample || typeof sample !== 'object') return;
            const payload = Object.assign({
                route: detectRoute(),
                connectionEffectiveType: connInfo(),
                deviceMemory_gb: deviceMem(),
                userAgent: navigator.userAgent,
                institution_id: getInstitutionId()
            }, sample);
            const hdrs = {
                'Content-Type': 'application/json'
            };
            const token = localStorage.getItem('access_token');
            if (token) hdrs.Authorization = 'Bearer ' + token;
            $74bb8a2006e9dcfb$var$originalFetch(ENDPOINT, {
                method: 'POST',
                headers: hdrs,
                body: JSON.stringify(payload),
                keepalive: typeof navigator.sendBeacon === 'undefined'
            }).catch(()=>{
            /* fire-and-forget: never surface to user */ });
        } catch (_rec) {
        /* absolutely never surface to user */ }
    }
    function measureTTI(markerName) {
        let tti = undefined;
        try {
            const nowTs = performance.now();
            tti = Math.round(nowTs);
            if (typeof performance.measure === 'function' && markerName) try {
                performance.measure(markerName, {
                    start: 0,
                    end: nowTs,
                    detail: {
                        metric: 'timeFromNavigationStartToFirstInteractiveRow_ms'
                    }
                });
            } catch (_measureModern) {
                try {
                    if (typeof performance.mark === 'function') {
                        performance.mark('__lukaperf_end_' + markerName);
                        try {
                            performance.measure(markerName, 'navigationStart', '__lukaperf_end_' + markerName);
                        } catch (_eNS) {
                            try {
                                performance.measure(markerName, '__lukaperf_end_' + markerName);
                            } catch (_e2) {}
                        }
                        try {
                            performance.clearMarks('__lukaperf_end_' + markerName);
                        } catch (_c) {}
                    }
                } catch (_measureFallback) {
                /* ignore measure errors */ }
            }
        } catch (_tti) {
        /* ignore */ }
        return tti;
    }
    function recordFirstInteractiveRow(extra) {
        try {
            const MARKER = 'timeFromNavigationStartToFirstInteractiveRow_ms';
            const tti = measureTTI(MARKER);
            const sample = Object.assign({
                [MARKER]: tti
            }, extra || {});
            record(sample);
            return tti;
        } catch (_rfir) {
            return undefined;
        }
    }
    global.LukaPerfBeacon = {
        record: record,
        measureTTI: measureTTI,
        recordFirstInteractiveRow: recordFirstInteractiveRow,
        DEV_MODE: DEV_MODE,
        SAMPLE_EVERY_N: SAMPLE_EVERY_N
    };
})(window);


//# sourceMappingURL=about.41a9f37b.js.map
